import { Alert, AlertTitle, Button, Box } from '@mui/material';

/**
 * Componente de estado de erro padronizado
 * 
 * @param {Error} error - Objeto de erro
 * @param {Function} onRetry - Callback para tentar novamente (opcional)
 * @param {string} title - Título customizado (opcional)
 * 
 * @example
 * {error && <ErrorState error={error} onRetry={reload} />}
 */
export default function ErrorState({ 
  error, 
  onRetry, 
  title = 'Erro ao carregar dados' 
}) {
  const errorMessage = error?.response?.data?.message 
    || error?.message 
    || 'Ocorreu um erro inesperado. Tente novamente mais tarde.';

  return (
    <Box py={4} px={2}>
      <Alert 
        severity="error"
        action={
          onRetry && (
            <Button 
              color="inherit" 
              size="small" 
              onClick={onRetry}
              sx={{ whiteSpace: 'nowrap' }}
            >
              Tentar novamente
            </Button>
          )
        }
      >
        <AlertTitle>{title}</AlertTitle>
        {errorMessage}
      </Alert>
    </Box>
  );
}
